import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CustomInput } from './styles';

export function FileName() {
	return (
		<Form.Item name={['original_name']} label={I18n.get('File name')}>
			<CustomInput placeholder={I18n.get('File name')} />
		</Form.Item>
	);
}
